/**
 * @param unix_time: number
 * @returns unix_time: string
 */

export const UnixToJapanDateTime = (unix_timestamp: number) => {
  const date = new Date(unix_timestamp * 1000); // UNIXタイムスタンプをミリ秒に変換
  return date.toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' });
};
